import { AnalyticsStoreProvider, useAnalyticsStoreContext } from '../../contexts';

import FormSubmissionCard from './FormSubmissionCard';
import DateRangeComparatorInput from '../../inputs/DateRangeComparatorInput';

function Submissions({ forms, endpoints }) {
  const { admin_analytics_form_path, total_submissions_api_v1_cms_analytic_path, submissions_during_period_api_v1_cms_analytic_path } = endpoints;

  const adminAnalyticsFormPath = (id) => admin_analytics_form_path.replace(':id', id);
  const totalSubmissionsPath = (id) => total_submissions_api_v1_cms_analytic_path.replace(':id', id);
  const submissionsDuringPeriodPath = (id) => submissions_during_period_api_v1_cms_analytic_path.replace(':id', id);

  const dateRange = useAnalyticsStoreContext((state) => state.data.first.dateRange);
  const dateRangeTwo = useAnalyticsStoreContext((state) => state.data.second.dateRange);
  const isComparing = useAnalyticsStoreContext((state) => state.isComparing);

  return (
    <div id="form-insights" className="d-flex flex-column justify-content-center gap-3" style={{ maxWidth: 1100 }}>
      <div className="d-flex justify-content-end">
        <DateRangeComparatorInput />
      </div>
      {forms.map((form) => (
        <FormSubmissionCard
          key={form.id}
          {...{ form, isComparing, dateRange, dateRangeTwo, adminAnalyticsFormPath, totalSubmissionsPath, submissionsDuringPeriodPath }}
        />
      ))}
    </div>
  );
}

export default function FormSubmissions(props) {
  return (
    <AnalyticsStoreProvider>
      <Submissions {...props} />
    </AnalyticsStoreProvider>
  );
}
